import RenderPage from './render-page';

export default RenderPage;